
import { Marked } from "marked";
import { link_extension } from "$lib/utils/marked.links";
import { cut_extension } from "$lib/utils/marked.cut";

export const resources_nav_items = [
        {
            path: '',
            title: 'For All Ages',
            header_suffix: '',
            min_age: null,
            max_age: null
        },
        {
            path: 'for-5-7-years-old',
            title: 'For Ages 5–7',
            header_suffix: 'for Ages 5–7',
            min_age: 5,
            max_age: 7
        },
        {
            path: 'for-8-12-years-old',
            title: 'For Ages 8–12',
            header_suffix: 'for Ages 8–12',
            min_age: 8,
            max_age: 12
        },
        {
            path: 'for-13-18-years-old',
            title: 'For Ages 13+',
            header_suffix: 'for Ages 13+',
            min_age: 13,
            max_age: 18
        }
    ];

/**
 * Parse markdown in resource descriptions and titles
 * @param {Array} resources - Array of resource categories
 * @returns {Array} - Parsed resources with HTML content
 */
export function parse_resources_markdown(resources) {
    if (!resources || !Array.isArray(resources)) return resources;

    const marked = new Marked({
        breaks: true,
        extensions: [
            link_extension,
            cut_extension
        ],
    });

    return resources.map(category => ({
        ...category,
        title: marked.parseInline(category.title || ''),
        items: category.items ? category.items.map(item => ({
            ...item,
            title: marked.parseInline(item.title || ''),
            description: marked.parse(item.description || '')
        })) : []
    }));
}